import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  userDetails: null,
  loggedInUser: null,
  token: null,
  users: [],
};

export const userslice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuthenticationToken: (state = initialState, { payload }) => {
      return {
        ...state,
        token: payload,
      };
    },
    loginAction: (state = initialState, { payload }) => {
      return {
        ...state,
        loggedInUser: payload,
      };
    },
    logOutAction: (state = initialState) => {
      return {
        ...state,
        ...initialState,
      };
    },
    setUserList: (state = initialState, { payload }) => {
      return {
        ...state,
        users: payload,
      };
    },
    createUser: (state, { payload }) => {
      state.users.push(payload);
    },
    detailUser: (state, { payload }) => {
      state.userDetails = payload;
    },
    updateUser: (state, { payload }) => {
      state.userDetails = { ...state.userDetails, ...payload };
    },
    deleteUser: (state, { payload }) => {
      const userIndex = state.users.findIndex((user) => user._id === payload);
      if (userIndex !== -1) {
        state.users.splice(userIndex, 1);
      }
      if (state.userDetails?._id === payload) {
        state.userDetails = null;
      }
    },
  },
});
